import countries from '../../data/countries';

const countryNameByCode = new Map(
    (countries || []).map((country) => [
        String(country.id || '').trim().toUpperCase(),
        country.name || String(country.id || '').trim().toUpperCase(),
    ])
);

export const captureDiscoveryFilters = (filters) => ({
    selectedCountry: filters.selectedCountry || '',
    selectedCity: filters.selectedCity || '',
    selectedIndustry: filters.selectedIndustry || '',
    aiIndustryGroup: filters.aiIndustryGroup || null,
    selectedStudyDirection: filters.selectedStudyDirection || '',
    selectedCompanySize: filters.selectedCompanySize || '',
    selectedCompanyRating: filters.selectedCompanyRating || '',
    selectedEnglishSpeaking: filters.selectedEnglishSpeaking === true ? true : null,
    selectedWorldTraveler: filters.selectedWorldTraveler === true ? true : null,
    selectedStudentJobAreas: filters.selectedStudentJobAreas === true ? true : null,
    selectedInternship: filters.selectedInternship === true ? true : null,
    selectedFavorites: filters.selectedFavorites === true ? true : null,
});

const formatStudyDirection = (value) => String(value || '')
    .trim()
    .replace(/^\d+(?:\.\d+)?\s*[-–—]?\s*/, '')
    .replace(/([.:])\s*\d+(?:\.\d+)?\s*[-–—]?\s*/g, '$1 ')
    .replace(/^\(\s*/, '')
    .replace(/\)\s*$/, '')
    .replace(/\s{2,}/g, ' ')
    .trim();

export const buildDiscoveryFilterChipLabels = (filters, industryNameByCode = new Map()) => [
    filters.selectedCountry && [
        'selectedCountry',
        countryNameByCode.get(String(filters.selectedCountry).trim().toUpperCase()) || filters.selectedCountry,
    ],
    filters.selectedCity && ['selectedCity', filters.selectedCity],
    (filters.aiIndustryGroup || filters.selectedIndustry) && [
        filters.aiIndustryGroup ? 'aiIndustryGroup' : 'selectedIndustry',
        filters.aiIndustryGroup || industryNameByCode.get(String(filters.selectedIndustry)) || filters.selectedIndustry,
    ],
    filters.selectedStudyDirection && ['selectedStudyDirection', formatStudyDirection(filters.selectedStudyDirection)],
    filters.selectedCompanySize && ['selectedCompanySize', filters.selectedCompanySize],
    filters.selectedCompanyRating && ['selectedCompanyRating', `Rating: ${filters.selectedCompanyRating}+`],
    filters.selectedEnglishSpeaking && ['selectedEnglishSpeaking', 'English speaking'],
    filters.selectedWorldTraveler && ['selectedWorldTraveler', 'World traveler'],
    filters.selectedStudentJobAreas && ['selectedStudentJobAreas', 'Student job areas'],
    filters.selectedInternship && ['selectedInternship', 'Internships'],
    filters.selectedFavorites && ['selectedFavorites', 'Saved to Favorites'],
].filter(Boolean).map(([key, label]) => ({ key, label }));
